module.exports = __webpack_public_path__ + "img/nlic_main1.39ec1da1.jpg";